import { render, staticRenderFns } from "./DialogAccountReportBB.vue?vue&type=template&id=037df78c&"
import script from "./DialogAccountReportBB.vue?vue&type=script&lang=js&"
export * from "./DialogAccountReportBB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports